import React from 'react';
import Select from 'react-select';

import { Spinner } from 'react-bootstrap';
import { eventService } from '../../_services/event.service';
import { useEffect, useState } from 'react';

export default function EventTypeOption({ defaultValue, handleSelected, textDark = false, disabled = false }) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    eventService.getTypes()
      .then((response) => {
        setOptions(response.data);
      });
  }, []);

  if (options.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const eventOptions = options.map((event) => {
    return { value: event.id, label: event.name }
  });

  const eventOptionSelected = eventOptions.find((event) => {
    return event.value === selected;
  });

  return <Select
    placeholder='Select...'
    isClearable={true}
    options={eventOptions}
    onChange={selected => {
      if (selected) {
        setSelected(selected.value);
        handleSelected(selected.value, selected.label);
      } else {
        setSelected('');
        handleSelected('', '');
      }
    }}
    isDisabled={disabled}
    styles={textDark && {
      singleValue: (styles) => {
        return {
          ...styles, color: 'black',
        };
      },
    }}
    value={eventOptionSelected || ''}
  />
}